import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import * as platform from '../../registry/common/platform.js';
import { Emitter } from '../../../base/common/event.js';
export var Extensions = {
  JSONContribution: 'base.contributions.json'
};

function normalizeId(id) {
  if (id.length > 0 && id.charAt(id.length - 1) === '#') {
    return id.substring(0, id.length - 1);
  }

  return id;
}

var JSONContributionRegistry = /*#__PURE__*/function () {
  function JSONContributionRegistry() {
    _classCallCheck(this, JSONContributionRegistry);

    this._onDidChangeSchema = new Emitter();
    this.schemasById = {};
  }

  _createClass(JSONContributionRegistry, [{
    key: "registerSchema",
    value: function registerSchema(uri, unresolvedSchemaContent) {
      this.schemasById[normalizeId(uri)] = unresolvedSchemaContent;

      this._onDidChangeSchema.fire(uri);
    }
  }, {
    key: "notifySchemaChanged",
    value: function notifySchemaChanged(uri) {
      this._onDidChangeSchema.fire(uri);
    }
  }]);

  return JSONContributionRegistry;
}();

var jsonContributionRegistry = new JSONContributionRegistry();
platform.Registry.add(Extensions.JSONContribution, jsonContributionRegistry);